<template>
  <div class="selected-items-bar" data-locator="multiselect-bar">
    <span class="mr-2 selected-items-count">
      {{ $t("common.selectedItems", allSelectedChecklistItems.length) }}
    </span>

    <AppButton
      class="mr-10"
      text
      color="primary"
      data-locator="unselect-all-button"
      @click="unselectAll"
    >
      {{ $t("common.cancelSelection") }}
    </AppButton>

    <MultiSelectBarButton :disabled="noTaskSelected" data-locator="share-button" @click="openShareSelectionDialog">
      <font-awesome-icon class="mr-2" :icon="['fas', 'share']" />
      {{ $t("common.share") }}
    </MultiSelectBarButton>

    <MultiSelectBarButton data-locator="delete-button" @click="deleteSelectionDialogIsOpen = true">
      <font-awesome-icon class="mr-2" :icon="['fas', 'trash']" />
      {{ $t("common.delete") }}
    </MultiSelectBarButton>

    <ChecklistDeleteSelectionDialog
        v-if="deleteSelectionDialogIsOpen"
        @close="deleteSelectionDialogIsOpen = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import AppButton from '@/common/buttons/AppButton.vue'
import MultiSelectBarButton from '@/common/buttons/MultiSelectBarButton.vue'
import ChecklistDeleteSelectionDialog from '@/project/checklist/dialogs/ChecklistDeleteSelectionDialog.vue'
import { CLEAR_ITEMS_SELECTION } from '@/store/modules/checklist/action_types'
import { SET_SHARE_TASKS_DIALOG } from '@/store/modules/checklist/mutation_types'


export default {
  name: 'ChecklistTableBulkActions',
  components: {
    AppButton,
    ChecklistDeleteSelectionDialog,
    MultiSelectBarButton,
  },
  data () {
    return {
      deleteSelectionDialogIsOpen: false,
    }
  },
  computed: {
    ...mapGetters('checklist', ['allSelectedChecklistItems', 'selectedTasks']),
    ...mapGetters('room', ['roomMnemo']),
    noTaskSelected () {
      return this.selectedTasks.length === 0
    },
  },
  beforeUnmount () {
    this.CLEAR_ITEMS_SELECTION()
  },
  methods: {
    ...mapActions('checklist', [CLEAR_ITEMS_SELECTION]),
    ...mapMutations('checklist', [SET_SHARE_TASKS_DIALOG]),
    unselectAll () {
      this.CLEAR_ITEMS_SELECTION()
    },
    openShareSelectionDialog () {
      this.SET_SHARE_TASKS_DIALOG({
        isOpen: true,
        tasksToShare: this.selectedTasks,
      })
    },
  },
}
</script>
